import { MKT_STATUS_TYPE } from 'helpers/marketplaceStatus';

const getPendingOfferStatus = ({ vehicle: { my_offer_amount } }) => ({
	unifiedStatusType: my_offer_amount ? MKT_STATUS_TYPE.nonStartedBuyerBid : MKT_STATUS_TYPE.awaitingBids,
});

export default getPendingOfferStatus;
